import React, {useEffect, useRef, useState} from 'react';
import {Pressable, StyleSheet} from 'react-native';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import {faArrowUpLong} from '@fortawesome/free-solid-svg-icons/faArrowUpLong';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

const styles = StyleSheet.create({
  container: {
    // width: 100,
    // height: 100,
    padding: 16,
    bottom: 16,
    right: 12,
    borderRadius: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'lightgrey',

    borderWidth: 0.5,
    borderColor: '#666',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,

    position: 'absolute',
  },
  pressable: {
    color: 'white',
  },
  icon: {
    color: 'grey',
  },
});

const ScrollToTopButton = ({open, callback}) => {
  let timer = useRef(null);
  const displayTimer = useRef(null);
  const opacityValue = useSharedValue(0);
  const [display, setDisplay] = useState(false);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: opacityValue.value,
    };
  });

  useEffect(() => {
    if (open) {
      setDisplay(true);
      clearTimeout(timer.current);
      opacityValue.value = withTiming(0.9, {duration: 250});
    } else {
      timer.current = setTimeout(() => {
        opacityValue.value = withTiming(0, {duration: 250});
      }, 2000);
    }
  }, [open, opacityValue]);

  useEffect(() => {
    if (!open && opacityValue.value > 0) {
      if (displayTimer.current) {
        clearTimeout(displayTimer.current);
      }
      setTimeout(() => {
        setDisplay(false);
      }, 2250);
    }
  }, [open, opacityValue]);

  if (!display) return null;

  return (
    <Animated.View
      style={[styles.container, animatedStyle]}
      testID="scroll-to-top-button-parent-animated-view">
      <Pressable style={styles.pressable} onPress={callback}>
        <FontAwesomeIcon icon={faArrowUpLong} size={24} style={styles.icon} />
      </Pressable>
    </Animated.View>
  );
};

export default ScrollToTopButton;
